import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MaterialModule } from '@huge-monorepo/shared/modules';
import { FormArray, FormBuilder, FormControl, Validators } from '@angular/forms';
@Component({
  selector: 'huge-monorepo-teltonika-edit-tag-modal',
  standalone: true,
  imports: [CommonModule, MaterialModule],
  templateUrl: './teltonika-edit-tag-modal.component.html',
  styleUrl: './teltonika-edit-tag-modal.component.scss',
})
export class TeltonikaEditTagModalComponent {
  name: string = '';
  description: string = '';
  emailsFormControl: FormArray<FormControl<string>> = new FormArray<FormControl<string>>([]);
  constructor(
    public dialogRef: MatDialogRef<TeltonikaEditTagModalComponent>,
    private formBuilder: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: { Description: string; Name: string; Emails: string[] },
  ) {
    this.description = data.Description;
    this.name = data.Name;
    if (data.Emails != null) {
      this.emailsFormControl = this.formBuilder.array(data.Emails.map(email => this.formBuilder.nonNullable.control(email ?? '', [Validators.email, Validators.required])));
    }
  }

  closeDialog(save: boolean): void {
    if (!save) {
      this.dialogRef.close({ Description: null, Emails: null });
      return;
    }

    if (this.emailsFormControl.invalid) {
      this.emailsFormControl.markAllAsTouched();
      return;
    }

    this.dialogRef.close({
      Description: this.description,
      Emails: this.emailsFormControl.controls.map((control) => control.value),
    });
  }

  addNewEmail(): void {
    this.emailsFormControl.push(this.formBuilder.nonNullable.control('', [Validators.email, Validators.required]));
  }
}
